<mat-card appearance="outlined" class="col-12 col-md-8 offset-md-2">
  <mat-card-title-group>
    <mat-card-title>{{title}}</mat-card-title>
    <mat-card-subtitle>{{companyName}}</mat-card-subtitle>
    <app-img-display [uid]="user.uid" [type]="'userAvatar'" [imageTs]="user.avatarTs"
      [showNoImage]="false"></app-img-display>
  </mat-card-title-group>
  <mat-card-content class="text-center">
    <div>{{text | translate}}</div>
    <button mat-flat-button color="primary" class="mt-2" (click)="doContact(title, email)">Contacter</button>
  </mat-card-content>
</mat-card>